import styled from 'styled-components'

import { Section as GSSection } from 'components/general-styles'
import { theme } from 'styles/theme'

const { media, space, colors } = theme

export const Section = styled(GSSection)`
  @media (${media.desktop}) {
    padding: 7.5rem 0;
    
    h2, span {
      font-size: 3.5rem;
    }
  }
`

export const ItemList = styled.div`
  padding-top: ${space['spacing-sm']};
`

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h3 {
    font-size: 1.125rem;
  }
  
  p {
    font-size: 1rem;
  }

  @media (${media.desktop}) {
    display: flex;
    flex-direction: row;
  }
`

export const Card = styled.div`
  border: solid ${colors['neutral-text-weak']} 1px;
  padding: ${space['spacing-sm']};
  border-radius: ${space['spacing-xs']};
  width: 100%;
`

export const CardHeading = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-md']};
`

export const IconImage = styled.div`
  width: 48px;
`
